import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {store} from './Redux/store'
import CartContextProvider from './Contexts/CartContext';
import SearchContextProvider from './Contexts/SearchContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <SearchContextProvider>
    <CartContextProvider>
    <App />
    </CartContextProvider>
    </SearchContextProvider>
    </BrowserRouter>
  </Provider>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
